module.exports = __webpack_public_path__ + "media/images/img_rounge_2-063e672b1e876c7eeb55eb8e4c5b473d.jpg";